import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAFrlRPdCMCI4I4hrTtVEX-DJXCqqCyoV4",
  authDomain: "slackclonechallenge-8f1e8.firebaseapp.com",
  projectId: "slackclonechallenge-8f1e8",
  storageBucket: "slackclonechallenge-8f1e8.appspot.com",
  messagingSenderId: "211174640087",
  appId: "1:211174640087:web:10422e1c306666c7496392",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
